import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/documents/arrow-right.svg")